export default __webpack_public_path__ + "static/media/unionpay.b1f2b994.svg";